import type { PlanId } from './PlanStatusCard.types';

export const PLAN_COLORS: Record<PlanId, { accent: string; barTrack: string; barFill: string; header: string }> = {
  despega: {
    accent: '#0D9488',
    barTrack: '#E2EBF0',
    barFill: 'linear-gradient(90deg,#14B8A6,#38BDF8)',
    header: 'linear-gradient(135deg,#14B8A6 0%,#38BDF8 100%)',
  },
  emprende: {
    accent: '#1662C5',
    barTrack: '#E2EBF0',
    barFill: '#1E6FD9',
    header: 'linear-gradient(135deg,#1E6FD9 0%,#5C9BEE 100%)',
  },
  maximiza: {
    accent: '#1B4A78',
    barTrack: '#E2EBF0',
    barFill: '#1B4A78',
    header: 'linear-gradient(135deg,#14375A 0%,#3179AE 100%)',
  },
  demo: {
    accent: '#334155',
    barTrack: '#E2E8F0',
    barFill: '#334155',
    header: 'linear-gradient(135deg,#334155 0%,#94A3B8 100%)',
  },
};
